export const EQUIPMENT_LABELS = {
  // Form title
  FORM_TITLE: 'Dodaj aparaturę', // Add Equipment
  FORM_TITLE_EDIT: 'Edytuj aparaturę', // Edit Equipment
  FIELD_EQUIPMENT_ID: 'ID aparatury',

  // Section headings
  SECTION_BASIC_DETAILS: 'Podstawowe dane sprzętu', // Basic Equipment Details
  SECTION_MEDIA_DOCUMENTS: 'Media i dokumenty', // Media & Documents
  SECTION_SAFETY_DOCUMENTS: 'Dokumenty bezpieczeństwa',
  SECTION_OPTIONAL: '(Opcjonalne)', // Safety Documents (optional)

  // Equipment image field
  FIELD_EQUIPMENT_IMAGE: 'Zdjęcie aparatury', // Equipment image

  // Field labels
  FIELD_NAME: 'Imię i nazwisko', // Name
  FIELD_DESCRIPTION: 'Opis', // Description
  FIELD_CATEGORY: 'Kategoria',
  FIELD_SERIAL_NUMBER: 'Numer seryjny',
  FIELD_DATE_OF_PRODUCTION: 'Data produkcji',
  FIELD_DATE_OF_PRODUCTION_PICKER_LABEL: 'Wybierz datę',
  FIELD_MODEL_NAME: 'Nazwa modelu',
  SECTION_BASIC_DETAILS_HEADING: 'Podstawowe dane',
  SECTION_EQUIPMENT_DETAILS_HEADING: 'Dane aparatury',

  // Buttons
  SUBMIT_BUTTON: 'Dodaj aparaturę', // Add Equipment
  SUBMIT_BUTTON_EDIT: 'Zapisz', // Save (edit mode)
  SUBMIT_BUTTON_LOADING: 'Dodawanie aparatury…',
  SUBMIT_BUTTON_LOADING_EDIT: 'Zapisywanie…',
  CANCEL_BUTTON: 'Anuluj', // Cancel
  REMOVE_BUTTON: 'Usuń ten sprzęt', // Remove this equipment

  // Tooltips - Equipment Image
  TOOLTIP_IMAGE_REQUIREMENTS: 'Wymagania dotyczące zdjęcia sprzętu:', // Equipment image requirements:
  TOOLTIP_IMAGE_FORMAT: 'Format: PNG, JPG lub JPEG', // Format: PNG, JPG or JPEG
  TOOLTIP_IMAGE_SIZE: 'Maksymalny rozmiar pliku: 5 MB', // Maximum file size: 5 MB
  TOOLTIP_IMAGE_COUNT: 'Maksymalnie 1 zdjęcie', // Maximum 1 image

  // Tooltips - Safety Documents
  TOOLTIP_DOCS_FORMAT: 'Format: PDF, DOCX, JPG, JPEG lub PNG', // Format: PDF, DOCX, JPG, JPEG or PNG
  TOOLTIP_DOCS_SIZE: 'Maksymalny rozmiar pliku: 5 MB', // Maximum file size: 5 MB
  TOOLTIP_DOCS_COUNT: 'Maksymalnie 2 pliki', // Maximum 2 files
} as const;
